export default function buildProductDetailModal(){
    App.prototype.riodeBuildProductDetailModal = function (data) {

        document.getElementById('riodeProductModal').dispatchEvent(new CustomEvent('set-product-event', { detail: {product: data}}));

        var el_whatsapp_input = $('.send-with-whatsapp [data-first-part]');

        if (el_whatsapp_input.length){
            var firstText = el_whatsapp_input.data('firstPart');

            el_whatsapp_input.val(firstText + ' ' + data.url);
        }

        setTimeout(() => {
            App.prototype.checkSingleLevelVariationStatus(JSON.parse(data.product_variation_data_as_json));
        });
    };
}
